import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "account-settings-card" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-sm-6" }
const _hoisted_4 = { class: "trezo-form-group" }
const _hoisted_5 = { class: "col-sm-6" }
const _hoisted_6 = { class: "trezo-form-group" }
const _hoisted_7 = { class: "col-sm-6" }
const _hoisted_8 = { class: "trezo-form-group" }
const _hoisted_9 = { class: "col-sm-6" }
const _hoisted_10 = { class: "trezo-form-group" }
const _hoisted_11 = { class: "col-sm-6" }
const _hoisted_12 = { class: "trezo-form-group" }
const _hoisted_13 = { class: "col-sm-6" }
const _hoisted_14 = { class: "trezo-form-group" }
const _hoisted_15 = { class: "col-sm-6" }
const _hoisted_16 = { class: "trezo-form-group" }
const _hoisted_17 = { class: "col-sm-6" }
const _hoisted_18 = { class: "trezo-form-group" }
const _hoisted_19 = { class: "col-sm-6" }
const _hoisted_20 = { class: "trezo-form-group" }
const _hoisted_21 = { class: "col-sm-6" }
const _hoisted_22 = { class: "trezo-form-group" }
const _hoisted_23 = { class: "col-sm-6" }
const _hoisted_24 = { class: "trezo-form-group" }
const _hoisted_25 = { class: "col-sm-6" }
const _hoisted_26 = { class: "trezo-form-group" }
const _hoisted_27 = { class: "col-sm-12" }
const _hoisted_28 = { class: "trezo-form-group" }
const _hoisted_29 = { class: "trezo-form-group" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-sm-6" }
const _hoisted_32 = { class: "trezo-form-group" }
const _hoisted_33 = { class: "col-sm-6" }
const _hoisted_34 = { class: "trezo-form-group" }
const _hoisted_35 = { class: "col-sm-6" }
const _hoisted_36 = { class: "trezo-form-group" }
const _hoisted_37 = { class: "col-sm-6" }
const _hoisted_38 = { class: "trezo-form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_label = _resolveComponent("v-label")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_FileUploader = _resolveComponent("FileUploader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[34] || (_cache[34] = _createElementVNode("h5", null, "Profile", -1)),
    _cache[35] || (_cache[35] = _createElementVNode("p", null, "Update your photo and personal details here.", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_label, { class: "main-label d-block fw-medium text-black" }, {
            default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
              _createTextVNode(" First Name ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_text_field, {
            label: "Enter first name",
            modelValue: _ctx.profile.firstName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.profile.firstName) = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_v_label, { class: "main-label d-block fw-medium text-black" }, {
            default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
              _createTextVNode(" Last Name ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_text_field, {
            label: "Enter last name",
            modelValue: _ctx.profile.lastName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.profile.lastName) = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_v_label, { class: "main-label d-block fw-medium text-black" }, {
            default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
              _createTextVNode(" Email Address ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_text_field, {
            label: "Enter email address",
            modelValue: _ctx.profile.email,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.profile.email) = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_v_label, { class: "main-label d-block fw-medium text-black" }, {
            default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
              _createTextVNode(" Phone Number ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_text_field, {
            label: "Enter phone number",
            modelValue: _ctx.profile.phone,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.profile.phone) = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_v_label, { class: "main-label d-block fw-medium text-black" }, {
            default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
              _createTextVNode(" Address ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_text_field, {
            label: "Enter address",
            modelValue: _ctx.profile.address,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.profile.address) = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_v_label, { class: "main-label d-block fw-medium text-black" }, {
            default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
              _createTextVNode(" Country ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_select, {
            label: "Select",
            items: _ctx.countries,
            modelValue: _ctx.profile.country,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.profile.country) = $event))
          }, null, 8, ["items", "modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_v_label, { class: "main-label d-block fw-medium text-black" }, {
            default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
              _createTextVNode(" Date Of Birth ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_text_field, {
            type: "date",
            class: "date-input",
            modelValue: _ctx.profile.dob,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.profile.dob) = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_v_label, { class: "main-label d-block fw-medium text-black" }, {
            default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
              _createTextVNode(" Gender ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_select, {
            label: "Select",
            items: _ctx.genders,
            modelValue: _ctx.profile.gender,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.profile.gender) = $event))
          }, null, 8, ["items", "modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_v_label, { class: "main-label d-block fw-medium text-black" }, {
            default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
              _createTextVNode(" Your Skills ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_select, {
            label: "Select",
            items: _ctx.skills,
            modelValue: _ctx.profile.skill,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.profile.skill) = $event))
          }, null, 8, ["items", "modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_v_label, { class: "main-label d-block fw-medium text-black" }, {
            default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
              _createTextVNode(" Your Profession ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_select, {
            label: "Select",
            items: _ctx.professions,
            modelValue: _ctx.profile.profession,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.profile.profession) = $event))
          }, null, 8, ["items", "modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_component_v_label, { class: "main-label d-block fw-medium text-black" }, {
            default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
              _createTextVNode(" Company Name ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_text_field, {
            label: "Enter company name",
            modelValue: _ctx.profile.companyName,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.profile.companyName) = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_component_v_label, { class: "main-label d-block fw-medium text-black" }, {
            default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
              _createTextVNode(" Company Website ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_text_field, {
            label: "Enter company website",
            modelValue: _ctx.profile.companyWebsite,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.profile.companyWebsite) = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createVNode(_component_v_label, { class: "main-label d-block fw-medium text-black" }, {
            default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
              _createTextVNode(" Add Your Bio ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_text_field, {
            label: "Type here....",
            modelValue: _ctx.profile.bio,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.profile.bio) = $event))
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _cache[36] || (_cache[36] = _createElementVNode("h4", null, "Your Photo", -1)),
    _cache[37] || (_cache[37] = _createElementVNode("p", null, "This will be displayed on your profile.", -1)),
    _createElementVNode("div", _hoisted_29, [
      _createVNode(_component_FileUploader)
    ]),
    _cache[38] || (_cache[38] = _createElementVNode("h4", null, "Socials Profile", -1)),
    _cache[39] || (_cache[39] = _createElementVNode("p", null, null, -1)),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createVNode(_component_v_label, { class: "main-label d-block fw-medium text-black" }, {
            default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
              _createTextVNode(" Facebook ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_text_field, {
            label: "Enter facebook link",
            modelValue: _ctx.profile.facebook,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.profile.facebook) = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _createVNode(_component_v_label, { class: "main-label d-block fw-medium text-black" }, {
            default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
              _createTextVNode(" X ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_text_field, {
            label: "Enter x link",
            modelValue: _ctx.profile.x,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.profile.x) = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _createVNode(_component_v_label, { class: "main-label d-block fw-medium text-black" }, {
            default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
              _createTextVNode(" Linkedin ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_text_field, {
            label: "Enter linkedin link",
            modelValue: _ctx.profile.linkedin,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.profile.linkedin) = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _createVNode(_component_v_label, { class: "main-label d-block fw-medium text-black" }, {
            default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
              _createTextVNode(" YouTube ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_text_field, {
            label: "YouTube",
            modelValue: _ctx.profile.youtube,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.profile.youtube) = $event))
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _cache[40] || (_cache[40] = _createElementVNode("div", { class: "form-btn-box" }, [
      _createElementVNode("button", {
        type: "button",
        class: "warn"
      }, "Cancel"),
      _createElementVNode("button", {
        type: "button",
        class: "primary"
      }, [
        _createElementVNode("i", { class: "material-symbols-outlined" }, " check "),
        _createTextVNode(" Update Profile ")
      ])
    ], -1))
  ]))
}